import { ThemeType } from './ThemeType'

export const Theme: ThemeType = {
  breakpoints: ['576px', '768px', '992px', '1200px', '1400px'],
  grid: {
    container: '130rem',
    gutter: '3.2rem',
  },
  border: {
    smallRadius: '8px',
    radius: '16px',
    xradius: '24px',
  },
  font: {
    roboto:
      "Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif",
    montserrat: 'Montserrat, sans-serif',
    comfortaa: 'Comfortaa, cursive',
    light: 300,
    normal: 400,
    semiBold: 500,
    bold: 600,
    xbold: 700,
    sizes: {
      xxxsmall: '0.875rem',
      normal: '1rem',
      xxsmall: '1.125rem',
      xsmall: '1.2rem',
      small: '1.4rem',
      medium: '1.5rem',
      large: '1.8rem',
      xlarge: '2.2rem',
      xxlarge: '2.8rem',
      huge: '4.6rem',
    },
  },
  colors: {
    primary: '#017849',
    secondary: '#00995D',
    mainBg: '#f2f2f2',
    white: '#fff',
    xxxlightGray: '#ededf6',
    xxlightGray: '#E0E0E0',
    xlightGray: '#c4c4c4',
    lightGray: '#BDBDBD',
    gray: '#8F8F8F',
    xgray: '#828282',
    darkGray: '#4f4f4f',
    black: '#4F4F4F',
    darkYellow: '#856404',
    lightYellow: '#fff3cd',
    red: '#EB5757',
    purple: '#7F7FD5',
    blue: '#2F80ED',
    lightGreen: '#addfcb',
  },
  spacings: {
    xxsmall: '0.8rem',
    xsmall: '1.6rem',
    small: '2.4rem',
    medium: '3.2rem',
    large: '4.0rem',
    xlarge: '4.8rem',
    xxlarge: '5.6rem',
  },
  transition: {
    default: '0.2s ease-in-out',
    fast: '0.1s ease-in-out',
  },
}
